import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import * as R from "ramda";
import { SpecsheetSVG } from "../specsheetImage/specsheetSVG.jsx";
import {
  specSheetCloseAuditModal,
  specSheetSetCurrentSpecsheetAuditRecord,
  specSheetSerCurrentThumbcutsAuditRecord,
  specsheetHandleForm,
} from "../specsheet/specsheet.redux";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import styled from "styled-components";
import Spinner from "../ui/Spinner";
import { SpecsContinued } from "../bowler/SpecsContinued";
import { validateValue } from "../../utils/utils";
import moment from "moment";
import { CaretLeftFill, CaretRightFill } from "react-bootstrap-icons";

const AuditModal = (props) => {
  const [disableTransition, setDisableTransition] = useState(false);
  const {
    specsheetAuditRecords,
    thumbcutsAuditRecords,
    specsheetHandleForm,
    showAuditModal,
    specSheetCloseAuditModal,
    gettingAuditRecords,
    specSheetSetCurrentSpecsheetAuditRecord,
    specSheetSerCurrentThumbcutsAuditRecord,
    currentSpecsheetAuditRecordIdx,
    currentSpecsheetAuditRecord,
    currentThumbcutsAuditRecordIdx,
    currentThumbcutsAuditRecord,
    flip_vh,
    default_vacu,
    default_vacu_increment,
    isOval,
    isRightHander,
    isOvalWidthDifference,
    isOvalWidthDecimal,
    isOvalWidthStartingBit,
    is2Hander,
    spanMeasurement,
  } = props;
  const { t } = useTranslation();

  const PanelSpecsheet = styled.div`
    font-size: 10px;
    position: relative;
    width: 100%;
  `;

  const PanelThumbcuts = styled.div`
    font-size: 10px;
    position: relative;
    width: 90%;
  `;

  const TitleBar = styled.div`
    display: flex;
    align-items: center;
    gap: ${(p) => p.theme.spacing.sm};
    color: ${(p) => p.theme.color.primary};
    font-family: ${(p) => p.theme.font.family};
    font-weight: ${(p) => p.theme.font.weightSemibold};
    font-size: ${(p) => p.theme.font.sizeLg};
    line-height: 1.2;
  `;

  const RecordMeta = styled.div`
    font-family: ${(p) => p.theme.font.family};
    font-size: ${(p) => p.theme.font.sizeSm};
    color: ${(p) => p.theme.color.textMuted};
    font-weight: ${(p) => p.theme.font.weightRegular};
    margin-top: 2px;
  `;

  const NavButton = styled(Button)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 36px;
    min-width: 44px;
    border-radius: ${(p) => p.theme.radius.md};
    font-size: ${(p) => p.theme.font.sizeSm};
    background: ${(p) => p.theme.color.primary};
    border-color: ${(p) => p.theme.color.primary};
    color: #ffffff;

    &:hover,
    &:focus,
    &:active,
    &:not(:disabled):not(.disabled):active {
      background: ${(p) => p.theme.color.primaryDark};
      border-color: ${(p) => p.theme.color.primaryDark};
      color: #ffffff;
    }
  `;

  useEffect(() => {
    if (gettingAuditRecords) {
      setTimeout(() => {
        setDisableTransition(true);
      }, 500);
    }
  }, [gettingAuditRecords]);

  const StyledModal = styled(Modal)`
    &.fade {
      transition: ${disableTransition ? "none" : "opacity .15s linear"};
      .modal-dialog {
        transition: ${disableTransition ? "none" : "transform .3s ease-out"};
      }
    }

    @media (min-width: 992px) and (orientation: landscape) {
      .modal-lg,
      .modal-xl {
        max-width: 1000px;
      }
    }

    @media (min-width: 992px) and (orientation: portrait) {
      .modal-lg,
      .modal-xl {
        max-width: 500px;
      }
    }

    .modal-content {
      background-color: #ffffff;
      border-top: 4px solid ${(p) => p.theme.color.primary};
      border-radius: ${(p) => p.theme.radius.md};
      overflow: hidden;
    }

    .modal-header {
      border-bottom: 1px solid ${(p) => p.theme.color.border};
      padding: ${(p) => p.theme.spacing.md};
    }

    .modal-body {
      min-height: 50vh;
      max-height: 75vh;
      overflow-y: auto;
      padding: ${(p) => p.theme.spacing.md};
    }

    .modal-footer {
      border-top: 1px solid ${(p) => p.theme.color.border};
      padding: ${(p) => p.theme.spacing.sm} ${(p) => p.theme.spacing.md};
    }
  `;

  const InfoCard = styled.div`
    background: ${(p) => p.theme.color.surfaceAlt};
    border-radius: ${(p) => p.theme.radius.md};
    padding: ${(p) => p.theme.spacing.md};
    text-align: center;
    font-family: ${(p) => p.theme.font.family};
    font-size: ${(p) => p.theme.font.sizeSm};
    color: ${(p) => p.theme.color.text};
    margin-bottom: ${(p) => p.theme.spacing.md};
  `;

  const BodyGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${(p) => p.theme.spacing.md};
    width: 100%;

    @media (min-width: 992px) and (orientation: landscape) {
      flex-direction: row;
      align-items: flex-start;
    }
  `;

  const BodyColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-width: 0;

    @media (min-width: 992px) and (orientation: landscape) {
      flex: 1 1 0;
    }
  `;

  const ButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: ${(p) => p.theme.spacing.sm};
  `;

  const RevisionLine = styled.div`
    font-family: ${(p) => p.theme.font.family};
    font-size: ${(p) => p.theme.font.sizeSm};
    color: ${(p) => p.theme.color.textMuted};
    text-align: center;
    margin-top: ${(p) => p.theme.spacing.xs};
  `;

  const SpinnerWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 40vh;
    width: 100%;
  `;

  const getDates = (specsheet) =>
    `${moment(specsheet.updated_at).format("L")} @ ${moment(
      specsheet.updated_at
    ).format("LT")}`;

  const closeAuditModal = () => {
    setDisableTransition(false);
    specSheetCloseAuditModal();
  };

  return (
    <StyledModal
      show={showAuditModal}
      onHide={() => {
        closeAuditModal();
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="gallery-popup"
      centered
    >
      <Modal.Header closeButton>
        <TitleBar>
          <span>
            {!gettingAuditRecords && currentSpecsheetAuditRecord
              ? validateValue(currentSpecsheetAuditRecord.name) === ""
                ? "No name"
                : currentSpecsheetAuditRecord.name
              : "History"}
          </span>
        </TitleBar>
      </Modal.Header>
      <Modal.Body
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {gettingAuditRecords && (
          <SpinnerWrap>
            <Spinner />
          </SpinnerWrap>
        )}
        {!gettingAuditRecords && currentSpecsheetAuditRecord && (
          <InfoCard>
            <div>
              {currentSpecsheetAuditRecord.revtype} ·{" "}
              {getDates(currentSpecsheetAuditRecord)}
            </div>
            <div>
              Revision {currentSpecsheetAuditRecordIdx + 1} of{" "}
              {specsheetAuditRecords.length}
            </div>
          </InfoCard>
        )}
        {!gettingAuditRecords && (
          <BodyGrid>
            <BodyColumn>
              <PanelSpecsheet>
                <SpecsheetSVG />
              </PanelSpecsheet>
              <ButtonsContainer>
                <NavButton
                  variant="primary"
                  onClick={() => {
                    if (currentSpecsheetAuditRecordIdx > 0) {
                      specSheetSetCurrentSpecsheetAuditRecord({
                        currentSpecsheetAuditRecordIdx:
                          currentSpecsheetAuditRecordIdx - 1,
                      });
                    }
                  }}
                >
                  <CaretLeftFill />
                </NavButton>
                <NavButton
                  variant="primary"
                  onClick={() => {
                    if (
                      currentSpecsheetAuditRecordIdx <
                      specsheetAuditRecords.length - 1
                    ) {
                      specSheetSetCurrentSpecsheetAuditRecord({
                        currentSpecsheetAuditRecordIdx:
                          currentSpecsheetAuditRecordIdx + 1,
                      });
                    }
                  }}
                >
                  <CaretRightFill />
                </NavButton>
              </ButtonsContainer>
            </BodyColumn>
            <BodyColumn>
              <PanelThumbcuts>
                <SpecsContinued
                  specsheet={currentSpecsheetAuditRecord}
                  flip_vh={flip_vh}
                  default_vacu={default_vacu}
                  default_vacu_increment={default_vacu_increment}
                  isOval={isOval}
                  isOvalCalculationVisible={false}
                  isRightHander={isRightHander}
                  specsheetShowThumbcutModal={false}
                  showThumbcutModal={false}
                  isOvalWidthDifference={isOvalWidthDifference}
                  isOvalWidthDecimal={isOvalWidthDecimal}
                  isOvalWidthStartingBit={isOvalWidthStartingBit}
                  isCalculating={false}
                  isReadOnly={true}
                  is2Hander={is2Hander}
                  spanMeasurement={spanMeasurement}
                />
              </PanelThumbcuts>
              {currentThumbcutsAuditRecord &&
                currentThumbcutsAuditRecord.length > 0 && (
                  <RevisionLine>
                    {currentThumbcutsAuditRecord[0].revtype} ·{" "}
                    {getDates(currentThumbcutsAuditRecord[0])}
                  </RevisionLine>
                )}
              <ButtonsContainer>
              <NavButton
                variant="primary"
                onClick={() => {
                  if (currentThumbcutsAuditRecordIdx > 0) {
                    specSheetSerCurrentThumbcutsAuditRecord({
                      currentThumbcutsAuditRecordIdx:
                        currentThumbcutsAuditRecordIdx - 1,
                    });
                  }
                }}
              >
                <CaretLeftFill />
              </NavButton>
              <NavButton
                variant="primary"
                onClick={() => {
                  if (
                    currentThumbcutsAuditRecordIdx <
                    thumbcutsAuditRecords.length - 1
                  ) {
                    specSheetSerCurrentThumbcutsAuditRecord({
                      currentThumbcutsAuditRecordIdx:
                        currentThumbcutsAuditRecordIdx + 1,
                    });
                  }
                }}
              >
                <CaretRightFill />
              </NavButton>
            </ButtonsContainer>
            </BodyColumn>
          </BodyGrid>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={() => closeAuditModal()}>
          Close
        </Button>
      </Modal.Footer>
    </StyledModal>
  );
};

export const SpecsheetAuditModal = connect(
  (state) => {
    const omitEmptyFields = (val) => val !== "";
    const currentSpecsheetAuditRecord = {
      ...R.pipe(R.pickBy(omitEmptyFields))(
        state.specsheet.currentSpecsheetAuditRecord
      ),
      thumb_cuts: state.specsheet.currentThumbcutsAuditRecord,
    };
    const isOval = R.path(["thm_type"])(currentSpecsheetAuditRecord) === "Oval";

    return {
      specsheetAuditRecords: state.specsheet.specsheetAuditRecords,
      thumbcutsAuditRecords: state.specsheet.thumbcutsAuditRecords,
      showAuditModal: state.specsheet.showAuditModal,
      gettingAuditRecords: state.specsheet.gettingAuditRecords,
      currentSpecsheetAuditRecordIdx:
        state.specsheet.currentSpecsheetAuditRecordIdx,
      currentSpecsheetAuditRecord,
      currentThumbcutsAuditRecordIdx:
        state.specsheet.currentThumbcutsAuditRecordIdx,
      currentThumbcutsAuditRecord: state.specsheet.currentThumbcutsAuditRecord,
      isPhone: state.userSession.deviceInfo.isMobileDevice,
      isOval,
      flip_vh: state.settings.appSettings.thumbHolePreferences.flip_vh,
      default_vacu: state.settings.appSettings.systemDefault.default_vacu,
      default_vacu_increment:
        state.settings.appSettings.systemDefault.default_vacu_increment,
      isOvalCalculationVisible:
        isOval &&
        state.settings.appSettings.thumbHolePreferences.oval_calculation !==
          "manual",
      isOvalWidthDifference:
        isOval &&
        state.settings.appSettings.thumbHolePreferences
          .oval_width_difference === "0",
      isOvalWidthDecimal:
        isOval &&
        state.settings.appSettings.thumbHolePreferences
          .oval_width_difference === "decimal",
      isOvalWidthStartingBit:
        isOval &&
        state.settings.appSettings.thumbHolePreferences
          .oval_width_difference === "64th",

      isRightHander: state.specsheet.currentSpecsheetAuditRecord
        ? state.specsheet.currentSpecsheetAuditRecord.hand === "right_hander"
        : true,
      isReadOnly: state.userSession.isReadOnly,
      spanMeasurement:
        state.settings.appSettings.systemDefault.span_measurement,
      is2Hander:
        state.bowlers.selectedCustomer?.style === "two_handed" ||
        state.bowlers.selectedCustomer?.style === "thumbless",
    };
  },
  {
    specSheetCloseAuditModal,
    specSheetSetCurrentSpecsheetAuditRecord,
    specSheetSerCurrentThumbcutsAuditRecord,
    specsheetHandleForm,
  }
)(AuditModal);
